import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import GroupService from 'Services/GroupService';

const GroupIndex = () => {
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        GroupService.getGroups()
            .then((result) => {
                if (result.status === 200) {
                    setGroups(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Group</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Groups</h2>
                <Link to="/admin/group/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {groups.length ? (
                        groups.map((group, key) => {
                            return (
                                <tr key={key}>
                                    <td>{group.name}</td>
                                    <td>{group.description}</td>
                                    <td>
                                        <Link to={`/admin/group/edit/${group.groupId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={`/admin/group/delete/${group.groupId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default GroupIndex;
